module.exports = __webpack_public_path__ + "img/niubi-logo.eb6208f6.png";